export const iconFontAwesomeShoppingCartPlus = (
	<i className="fa-solid fa-cart-plus"></i>
);
